import Swiper from '/src/components/swiper/swiper';

reviewsSwiperLogic();

export function reviewsSwiperLogic() {
  const swiperElement = document.querySelector('.reviews-swiper');

  if (swiperElement) {
    const initSwiper = () => {
      const reviewsSwiper = new Swiper(swiperElement, {
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          prevEl: '.reviews-swiper-btn-prev',
          nextEl: '.reviews-swiper-btn-next',
        },
        pagination: {
          el: '.reviews-swiper-pagination',
          // clickable: true,
        },
        loop: true,
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 8,
        autoHeight: true,
        // autoplay: {
        //   delay: 5000,
        //   // disableOnInteraction: false,
        //   pauseOnMouseEnter: true,
        // },
        breakpoints: {
          768: { slidesPerView: 2, slidesPerGroup: 2, },
          // 1440: { slidesPerView: 3, slidesPerGroup: 3, },
        },
      });
    };

    // Перевірка на наявність Swiper
    if (typeof Swiper !== 'undefined') {
      initSwiper();
    } else {
      // Якщо Swiper ще не завантажений, спробуємо ще раз, коли він буде готовий
      window.addEventListener('DOMContentLoaded', initSwiper);
    }
  }
}
